import React from 'react';
import Snackbar, { SnackbarProps } from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import { TransitionProps } from '@material-ui/core/transitions';
import Slide from '@material-ui/core/Slide';
import withThemeProvider from '../util/withThemeProvider';

export type SolvSnackbarProps = {
  isDismissable?: boolean;
  onClose: (event: React.SyntheticEvent | React.MouseEvent, reason?: string) => void;
} & SnackbarProps;

const SlideUpTransition = (props: TransitionProps) => <Slide {...props} direction="up" />;

const SolvSnackbar = ({ onClose, isDismissable, ...rest }: SolvSnackbarProps) => (
  <Snackbar
    action={
      isDismissable && (
        <IconButton aria-label="close" color="inherit" onClick={onClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      )
    }
    onClose={onClose}
    TransitionComponent={SlideUpTransition}
    {...rest}
  />
);

export default withThemeProvider(SolvSnackbar);
